import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const smartsheet = defineConnector({
  identifier: "smartsheet",
  name: "Smartsheet",
  tagLine: "Work management and collaboration",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.smartsheet\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Generate an access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Smartsheet, go to **Account › Personal Settings › API Access** and generate a new access token.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Smartsheet access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.smartsheet.com/2.0/users/me",
  },
});
